import React, { useContext } from "react"
import MapManager from "@/components/maps/MapManager"

type MapContextValue = {
  mapManager: MapManager | null
}

export const MapContext = React.createContext<MapContextValue>(
  {} as MapContextValue,
)

export function useMapContext(): MapManager | null {
  const { mapManager } = useContext(MapContext)

  return mapManager
}
